import React, { useMemo } from 'react'
import _ from 'lodash'

const MatchScores = (props) => {

  const { results, results_matchDay } = props

  const _results = results ? results : results_matchDay

  const { scores, score, scoreDisplays, winner } = _results ?? {}
  const { pointDifference } = scoreDisplays ?? {}
  const { points, team } = pointDifference ?? {}
  const { name } = winner ?? {}

  const winnerHasMostPoints = name === team

  const scrz = useMemo(() => {
    if (!scores && !score) return
    if (!_.isEmpty(scores)) {
      let scrd = []
      scrd = _.map(scores, (score, setNumber) => (
        <div className='abs slo'><span className='abw'>{score.away}</span><span>-</span><span className='abl'>{score.home}</span></div>
      ))
      scrd.unshift(<div className={winnerHasMostPoints ? 'whmp' : 'lhmp'}> {'PD: ' + points}</div>)
      return scrd
    } else if (score) {
      return <div className='abs'><span className='abw'>{score.away}</span><span>-</span><span className='abl'>{score.home}</span></div>
    }
  }, [scores, score])

  return scrz

}

export default MatchScores